import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from '../../../util/reactIntl';
import { NamedLink, IconButtonArrow, IconSearch, IconLandscapes } from '../../../components';
import Field, { hasDataInFields } from '../../../containers/PageBuilder/Field';
import { parseLandscapeCardText } from '../../../util/cmsPageHelper';
import css from './LandscapeCard.module.css';

const FieldMedia = props => {
  const { className, media, sizes, options } = props;
  const hasMediaField = hasDataInFields([media], options);
  return hasMediaField ? (
    <div className={classNames(className, css.media)}>
      <Field data={media} sizes={sizes} options={options} />
    </div>
  ) : null;
};

const LandscapeCard = props => {

  const {
    rootClassName = null,
    className = null,
    landscape
  } = props;

  if (!landscape) return null;

  const classes = classNames(rootClassName || css.root, className);

  const searchUrl = landscape?.callToAction?.href?.replace("/s?", "");
  const pageId = landscape?.media?.link?.href?.replace("/p/", "");
  const media = landscape?.media;

  const description = landscape?.text?.content;
  const { subTitle, text } = parseLandscapeCardText(description);

  return (
    <div className={classes}>
      <div className={css.rootForImage}>
        <FieldMedia
          media={media}
          sizes={"(max-width: 767px) 100vw, 568px"}
        />
        {pageId && (
          <div className={css.landscape}>
            <span className={css.landscapeTitle}>
              <FormattedMessage id="ListingPage.rewildingLandscape" />
            </span>
            <IconLandscapes type={pageId.replace("landscape-", "")} />
          </div>
        )}
      </div>
      <div className={css.info}>
        <div className={css.category}>
          {subTitle}
        </div>
        <h3 className={css.title}>
          {landscape?.title?.content}
        </h3>
        <p className={css.description}>
          {text}
        </p>

        <div className={css.actionButtons}>
          <NamedLink className={css.pageLink} name="CMSPage" params={{ pageId }}>
            <IconButtonArrow />
            <FormattedMessage id="ListingPage.readFullStory" />
          </NamedLink>

          <NamedLink className={css.searchLink} name="SearchPage" to={{ search: searchUrl }}>
            <IconSearch />
            <FormattedMessage id="ListingPage.searchListings" />
          </NamedLink>
        </div>
      </div>
    </div>
  );
};

export default LandscapeCard;
